import React, { Component } from 'react'
import { Field, Form, reduxForm } from 'redux-form'

import Button from 'components/Button'
import SelectPretty from 'components/Input/SelectPretty'
import { Input } from 'components/Input/Input'

import s from './BlogFilterModal.scss'
import cn from 'classnames'
import sText from 'components/Text/Text.scss'
import sLay from 'styles/modules/layout.scss'
import { isUndefined, omitBy } from 'lodash'

class BlogFilterModal extends Component {
  onSubmitAlt = fields => {
    const { replace, location, modalConfirm } = this.props

    replace({
      pathname: location.pathname,
      query: {
        ...location.query,
        ...omitBy(fields, isUndefined),
      },
    })
    modalConfirm()
  }
  render() {
    const { handleSubmit, authors, categories } = this.props
    const categoryOptions = categories.map(item => ({
      value: item.fields.name,
      name: item.fields.name,
    }))
    const authorOptions = authors.map(item => ({ value: item.fields.name, name: item.fields.name }))

    return (
      <div
        className={cn(sLay['layout-column'], sLay['layout-align-center-center'], sLay.flex, s.body)}
      >
        <Form
          onSubmit={handleSubmit(this.onSubmitAlt)}
          className={sText.descrip4}
          style={{ width: '100%' }}
        >
          <Field name="searchTerm" label="Search" component={Input} />
          <Field
            name="category"
            label="Category"
            component={SelectPretty}
            options={categoryOptions}
          />
          <Field name="author" label="Author" component={SelectPretty} options={authorOptions} />
        </Form>
        <div className={cn(sLay['layout-xs-column'], sLay['layout-gt-xs-row'])}>
          <Button
            style={{ marginTop: '30px' }}
            type="submit"
            color="tertiary"
            onClick={handleSubmit(this.onSubmitAlt)}
          >
            Filter
          </Button>
        </div>
      </div>
    )
  }
}

export default reduxForm({
  form: 'blogFilter',
})(BlogFilterModal)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Blog/BlogFilterModal/BlogFilterModal.jsx